// eslint-disable-next-line no-restricted-imports
import { GlobalFinancialMonitoringPartOneDto_Input } from 'api/generated/graphql';
import { LegalClientSaveGlobalFinancialMonitoringPartOneParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseLegalClientSaveGlobalFinancialMonitoringPartOneParam = (
  data: LegalClientSaveGlobalFinancialMonitoringPartOneParam
): GlobalFinancialMonitoringPartOneDto_Input => ({
  isSubjectToRegulation: data.isSubjectToRegulation,
  partOneInfo:
    data.isSubjectToRegulation && data.partOneInfo
      ? {
          supervisoryAuthorityNameAndLocation:
            data.partOneInfo.supervisoryAuthorityNameAndLocation,

          hasMandatoryAmlRegulations:
            data.partOneInfo.hasMandatoryAmlRegulations!,

          mandatoryAmlRegulation: data.partOneInfo.mandatoryAmlRegulation
            ? {
                regulationDetails:
                  data.partOneInfo.mandatoryAmlRegulation.regulationDetails!,
                authorizedBodyName:
                  data.partOneInfo.mandatoryAmlRegulation.authorizedBodyName!,
              }
            : undefined,

          lastAmlAuditResult: data.partOneInfo.lastAmlAuditResult,

          hadInvestigationsOrSanctions:
            data.partOneInfo.hadInvestigationsOrSanctions!,

          amlDecisionDateAndAuthorityInfo:
            data.partOneInfo?.amlDecisionDateAndAuthorityInfo,

          hasInternalAmlDocuments: data.partOneInfo?.hasInternalAmlDocuments!,

          internalAmlDocuments: data.partOneInfo.internalAmlDocuments
            ? {
                adoptionDate: formatToISODate(
                  data.partOneInfo.internalAmlDocuments.adoptionDate!
                ),
                lastUpdateDate: formatToISODate(
                  data.partOneInfo.internalAmlDocuments.lastUpdateDate!
                ),
                hasEffectivenessAssessmentProcedures:
                  data.partOneInfo.internalAmlDocuments
                    .hasEffectivenessAssessmentProcedures!,
                lastEffectivenessCheckInfo:
                  data.partOneInfo.internalAmlDocuments
                    .lastEffectivenessCheckInfo,
                appliesToForeignAffiliates:
                  data.partOneInfo.internalAmlDocuments
                    .appliesToForeignAffiliates,
              }
            : undefined,

          hasDepartmentsResponsibleForAmlFunctions:
            data.partOneInfo?.hasDepartmentsResponsibleForAmlFunctions!,

          amlFunctionDepartmentsNames:
            data.partOneInfo?.amlFunctionDepartmentsNames,

          hasResponsibleAmlManager: data.partOneInfo?.hasResponsibleAmlManager!,

          responsibleAmlManager: data.partOneInfo.responsibleAmlManager
            ? {
                fullName: data.partOneInfo.responsibleAmlManager.fullName!,
                position: data.partOneInfo.responsibleAmlManager.position!,
                email: data.partOneInfo.responsibleAmlManager.email!,
                phoneNumber:
                  data.partOneInfo.responsibleAmlManager.phoneNumber!,
              }
            : undefined,

          hasRiskManagementProcedures:
            data.partOneInfo.hasRiskManagementProcedures ?? false,
        }
      : null,
});
